import { FleetManagementRow } from "../types/FleetManagement-row.types";
import { FleetStatus } from "../types/FleetManagement.types";

/**
 * For booking process, update fleet status
 * to show only available or occupied but not blocked
 */
export function filterByBookable({
  item,
  sub,
  department,
  companyId
}: {
  item: FleetManagementRow;
  sub: string;
  department: string;
  companyId: number;
}) {
  if (item.status === FleetStatus.Available) return item;

  if (item.status === FleetStatus.Blocked) return false;

  if (item.status === FleetStatus.Booked) {
    const { affectedCompanies, affectedDepartments, affectedUsers } = item;

    // if no permissions are assigned
    if (!affectedCompanies.length && !affectedDepartments.length && !affectedUsers.length) {
      return item;
    }

    // Normalize to string so backend numeric ids match (e.g. companyId 100 matches "100").
    const companyMatch = affectedCompanies.some(c => String(c) === String(companyId));
    const departmentMatch = affectedDepartments.some(d => String(d) === String(department));
    const userMatch = affectedUsers.some(u => String(u) === String(sub));

    return companyMatch || departmentMatch || userMatch;
  }

  return { ...item };
}
